import { Component, OnInit, Input } from '@angular/core';
import  {DatePipe} from '@angular/common'
import { AgregarPersona, ModelEstados } from 'src/app/model/persons/agregarpersona.model';
import { CatalogosService } from 'src/services/catalogos/catalogos.service';
import { AppComponent } from 'src/app/app.component';
import { PersonaService } from 'src/services/persona/persona.service';
import { SweetServices } from 'src/services/sweet.services';
import { SessionSotrageService } from 'src/services/session-sotrage.service';
import { NgForm } from '@angular/forms';
import { Console } from 'console';
import * as moment from 'moment'

@Component({
  selector: 'app-agregar-personas',
  templateUrl: './agregar-personas.component.html',
  styleUrls: ['./agregar-personas.component.css']
})
export class AgregarPersonasComponent implements OnInit {

  // tslint:disable-next-line: no-input-rename
  @Input('tipoPersona') tipoPersona: any;

  persona: AgregarPersona;
  Nacionalidad: string;
  PaisId: number;
  formatoRFC: boolean;
  errorEstatura: boolean;
  errorCorreo: boolean;


  /*Catálogos*/
  personalidadFiscal: [];
  estatus: [];
  paises: [];
  estados: ModelEstados[];
  sexos: [];
  estadosciviles: [];
  sucursales: [];
  actividades: [];
  ingresos: [];
  antiguedades: [];
  areas: [];
  contrataciones: [];
  puestos: [];


  constructor(private catalogoService: CatalogosService,
              private main: AppComponent, private personaService: PersonaService,
              private alerta: SweetServices, private ssstorage: SessionSotrageService) {
    this.persona = new AgregarPersona(this.tipoPersona);
    this.formatoRFC = false;
    this.errorEstatura = false;
  }

  ngOnInit() {
    this.persona.TipoPersona = this.tipoPersona;
    this.personalidadFiscal = this.catalogoService.getPersonalidadFiscal();
    this.estatus = this.catalogoService.getEstatus();
    this.paises = this.catalogoService.getPais();
    this.sexos = this.catalogoService.getSexo();
    this.estadosciviles = this.catalogoService.getEstadoCivil();
    this.sucursales = this.catalogoService.getSucursal();
    this.actividades = this.catalogoService.getActividadEconomica();
    this.ingresos = this.catalogoService.getIngresoMensual();
    this.antiguedades = this.catalogoService.getAntiguedad();
    this.areas = this.catalogoService.getArea();
    this.contrataciones = this.catalogoService.getContratacion();
    this.puestos = this.catalogoService.getPuesto();
    this.PaisId = -1;

    if(this.persona.TipoPersona == 1) this.persona.Persona.PersonalidadFiscalId = 1;
  }

  guardarPersona(formPersona: NgForm) {
    var valida = true;
    var fechaNacimientoValida = new Date(Date.now());
    var fechaNacimientoDate = new Date(fechaNacimientoValida.getFullYear() - 18, fechaNacimientoValida.getMonth(), fechaNacimientoValida.getDate());
    var newDate = new Date(this.persona.Persona.FechaNacimiento);

    this.validarCorreo();

    if(this.errorCorreo){
      return;
    }

    if(this.persona.Persona.PersonalidadFiscalId == 1 || this.persona.Persona.PersonalidadFiscalId == 3){
      if( newDate > fechaNacimientoDate){
        this.persona.Persona.FechaNacimiento = "";
        return;
      }
    }
    else if(this.persona.Persona.PersonalidadFiscalId == 2){
      if( newDate > fechaNacimientoValida){
        this.persona.Persona.FechaNacimiento = "";
        return;
      }
    }


    if (this.errorEstatura) {
      return;
    }
    if (formPersona.valid) {
      this.main.loading = true;

      this.validarPersona();

      this.persona.Persona.UsuarioId = this.ssstorage.getCurrentUser().usuarioId;
      this.persona.Persona.PersonalidadFiscalId = +this.persona.Persona.PersonalidadFiscalId;
      this.persona.Persona.EstadoId = +this.persona.Persona.EstadoId;
      this.persona.Persona.SexoId = +this.persona.Persona.SexoId;
      this.persona.Persona.EstadoCivilId = +this.persona.Persona.EstadoCivilId;
      this.persona.Persona.EstatusId = +this.persona.Persona.EstatusId;

      if (this.persona.TipoPersona == 2)
      {
        this.persona.Cliente.ActividadEId = +this.persona.Cliente.ActividadEId;
        this.persona.Cliente.IngresoId = +this.persona.Cliente.IngresoId;
        this.persona.Cliente.AntiguedadId = +this.persona.Cliente.AntiguedadId
        this.persona.Cliente.RiesgoId = +this.persona.Cliente.RiesgoId;
        this.persona.Cliente.SucursalId = +this.persona.Cliente.SucursalId;
      }
      if (this.persona.TipoPersona == 1)
      {
        var dateIngreso = new Date(this.persona.Empleado.FechaIngreso);
        this.persona.Empleado.ContratacionId =+this.persona.Empleado.ContratacionId;
        this.persona.Empleado.Estatura =+this.persona.Empleado.Estatura;
        this.persona.Empleado.SucursalId =+this.persona.Empleado.SucursalId;
        this.persona.Empleado.AreaId =+this.persona.Empleado.AreaId;
        this.persona.Empleado.PuestoId =+this.persona.Empleado.PuestoId;
        if( dateIngreso > fechaNacimientoValida){
          this.persona.Empleado.FechaIngreso = "";
          this.main.loading = false;
          return;
        }

      }
      let d = new Date(this.persona.Persona.FechaNacimiento);
      this.persona.Persona.FechaNacimiento = moment(d).format('DD/MM/YYYY');

      this.personaService.guardar(this.persona).subscribe(response => {
        if (response === null) {
          this.main.loading = false;
          this.alerta.AlertaError('Existe un error, si persiste contacte al administrador del Sitio.');
        } else if (response.isCorrect === 'false') {
          this.main.loading = false;
          this.alerta.AlertaError(response.message);
        } else {
          this.main.loading = false;
          this.alerta.AlertaSuccessTimer(response.message);
          setTimeout(() => {
            this.persona = new AgregarPersona(this.tipoPersona);
            this.PaisId = -1;
            this.Nacionalidad = '';
          }, 1500);
        }
      }, (err) => {
        this.main.loading = false;
        if (err.error.message == null) {
          this.alerta.AlertaCatch(err);
        } else {
          this.alerta.AlertaError(err.error.message);
        }
      });
    }
  }

  seleccionarEstado(paisId: number) {
    this.main.loading = true;
    this.catalogoService.buscarCatalogo('estado/pais/' + paisId).subscribe(response => {
      this.estados = response.data.info.result;
    });
    for (const pais of this.paises) {
      // tslint:disable-next-line: no-string-literal
      if (pais['paisId'] == paisId) {
        // tslint:disable-next-line: no-string-literal
        this.Nacionalidad = pais['nacionalidad'];
      }
    }
    setTimeout(() => {
      this.main.loading = false;
    }, 1000);
  }

  reiniciar(tipoPersona) {
    this.persona = new AgregarPersona(this.tipoPersona);
    this.persona.TipoPersona = tipoPersona;
  }

  private validarPersona() {
    if (this.persona.TipoPersona == 1) {
      this.persona.PersonaRelacionada = null;
      this.persona.Cliente = null;
      this.persona.Usuario = null;
    } else if (this.persona.TipoPersona == 2) {
      this.persona.PersonaRelacionada = null;
      this.persona.Empleado = null;
      this.persona.Usuario = null;
    } else if (this.persona.TipoPersona == 3) {
      this.persona.Empleado = null;
      this.persona.Cliente = null;
      this.persona.Usuario = null;
    } else if (this.persona.TipoPersona == 4) {
      this.persona.Empleado = null;
      this.persona.Cliente = null;
      this.persona.PersonaRelacionada = null;
    }
  }

  validarRFC() {
    const regexpFisica = new RegExp(/([A-Z,Ñ,&]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z|\d]{3})$/)
    const regexpMoral = new RegExp(/^(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))/)
    let result = false;
    this.persona.Persona.RFC = this.persona.Persona.RFC.toUpperCase();

    if(this.persona.Persona.PersonalidadFiscalId != 2){
      result = regexpFisica.test(this.persona.Persona.RFC);
  }
  if(this.persona.Persona.PersonalidadFiscalId == 2){
    result = regexpMoral.test(this.persona.Persona.RFC);
  }

    this.formatoRFC = !result;
  }

  validarEstatura(){
    this.errorEstatura = false;
    if(this.persona.Empleado.Estatura > 999.99){
      this.errorEstatura = true;
    }
  }

  validarCorreo(){
    this.errorCorreo = false;
    if(this.persona.Persona.Correo.length < 5){
      this.errorCorreo = false;
    }
  }

  cambioPersonalidad(personalidadFiscal: number, tipoPersona: number) {
    if (personalidadFiscal > -1) {
      this.persona = new AgregarPersona(this.tipoPersona);
      this.persona.Persona.PersonalidadFiscalId = personalidadFiscal;
      this.persona.TipoPersona = tipoPersona;
    }

    if (personalidadFiscal == 2) {
      this.persona.Persona.SexoId = 0;
      this.persona.Persona.EstadoCivilId = 0;
      this.persona.Cliente.IngresoId = 0;
      this.persona.Cliente.SucursalId = 0;
      this.persona.Cliente.AntiguedadId = 0;
      this.persona.Persona.ApellidoPaterno = '';
      this.persona.Persona.ApellidoMaterno = '';
    }
  }

  public blurEvent() {
    if(this.persona.Persona.Nombre != '' &&
    this.persona.Persona.ApellidoPaterno != '' &&
    this.persona.Persona.ApellidoMaterno != '' &&
    this.persona.Persona.EstadoId != -1 &&
    this.persona.Persona.SexoId != -1
    ){
      // To-Do
      // Se comenta por desicion de Mario M. se debe de revisar la funcionalidad inicial y plantear
      // Si se debe de usar ese metodo, mejorar o eliminar.

      // this.generarRFC();
    }
  }

  generarRFC() {
    //this.appLoading.loading = true;
    //this.deshabilitarLogin.Login = this.user.login;
    this.persona.Persona.EstatusId = Number(this.persona.Persona.EstatusId);
    this.persona.Persona.EstadoId = Number(this.persona.Persona.EstadoId);
    this.persona.Persona.PersonalidadFiscalId = Number(this.persona.Persona.PersonalidadFiscalId);
    this.persona.Persona.SexoId = Number(this.persona.Persona.SexoId);

    let val = this.estados.filter(xi => {
      if (xi.estadoId == Number(this.persona.Persona.EstadoId))
        return xi.abreviatura;
    })

    this.persona.Persona.Abreviatura = val[0].abreviatura;


      this.personaService.generarRFC(this.persona).subscribe(response => {
        if (response === null) {
          //this.appLoading.loading = false;
          this.alerta.AlertaError('Existe un error, si persiste contacte al administrador del Sitio.');
        } else if (response.isCorrect === 'false') {
          //this.appLoading.loading = false;
          this.alerta.AlertaError(response.message);
        } else {
          //this.appLoading.loading = false;
          //this.correctResetpass();
          this.persona.Persona.CURP = response.data.info.result;
        }
      }, (err) => {
        //this.appLoading.loading = false;
        this.alerta.AlertaCatch(err);
      }
      );
  }

}
